import Raven from 'raven-js';
import { apiClientWithMiddleware } from '../../../api/utils';
export const getIsSandboxPortal = portalId => {
  if (!portalId) return Promise.resolve(null);
  const path = `/hubs/v1/hubs/${portalId}/?portalId=${portalId}`;
  const config = {
    maxRetries: 2
  };
  return apiClientWithMiddleware(config).get(path).then(response => response).catch(err => {
    console.log('err', err);
    Raven.captureException(err);
    return null;
  });
};
export const getSandboxPortalParent = portalId => {
  if (!portalId) return Promise.resolve(null);
  const path = `/sandbox-hubs/v1/self/?portalId=${portalId}`;
  return apiClientWithMiddleware().get(path).then(response => response).catch(err => {
    Raven.captureException(err);
    return null;
  });
};
export const getRedirect = () => {
  try {
    return window.localStorage.getItem('SANDBOXES_REDIRECT') || 'sandboxes';
  } catch (error) {
    return 'sandboxes';
  }
};